import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, withCtx as _withCtx, createBlock as _createBlock } from "vue"

import { VueperSlides, VueperSlide } from 'vueperslides';
import 'vueperslides/dist/vueperslides.css';

import { PartnerOffer } from '@/features/partnerOffers/model';
import { displayModalOffer, displayedModalContext, displayedModalOffer } from './state';
import { logInteraction } from './api';
import OfferCard from './OfferCard.vue';
import { InteractionType } from '@/features/analytics/api';


export default /*#__PURE__*/_defineComponent({
  __name: 'OffersCarousel',
  props: {
    offers: null,
    context: null
  },
  setup(__props: any) {

const props = __props as {
  offers: PartnerOffer[],
  context: string,
}



const onClick = (offer: PartnerOffer) => {
  displayModalOffer(props.context, offer);
  logInteraction(props.context, offer, InteractionType.CLICK, "carousel");
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(VueperSlides), {
    class: "carousel",
    touchable: false,
    fixedHeight: ""
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.offers, (offer) => {
        return (_openBlock(), _createBlock(_unref(VueperSlide), {
          key: offer.id,
          onClick: ($event: any) => (onClick(offer)),
          style: {"cursor":"pointer"}
        }, {
          content: _withCtx(() => [
            _createElementVNode("div", {
              class: "desktopContent",
              style: _normalizeStyle({'background-image': `url(${offer.carouselImage || '/img/partner_offer_carousel_placeholder.png'})`})
            }, null, 4),
            _createVNode(OfferCard, {
              class: "mobileContent",
              offer: offer,
              context: __props.context
            }, null, 8, ["offer", "context"])
          ]),
          _: 2
        }, 1032, ["onClick"]))
      }), 128))
    ]),
    _: 1
  }))
}
}

})